import { combineReducers } from 'redux'

import arquivosLicitacao from './arquivosLicitacao'

export default combineReducers({ arquivosLicitacao })
